import React, { useState } from "react";
import client, { apiErr } from "../../lib/api";
import { toast } from "sonner";
import { PlusCircle } from "lucide-react";
import { Field, inputCls } from "../team/shared";

const BLANK = { mt5_id: "", amount: "", member_id: "", client_name: "", broker: "", note: "" };

export function ManualBrokerage({ members, period, onSaved }) {
  const [f, setF] = useState(BLANK);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async () => {
    if (!f.mt5_id.trim()) { toast.error("MT5 ID daalein (Manual Entry ke 'MT5 ID' box me)"); return; }
    if (f.amount === "" || isNaN(Number(f.amount))) { toast.error("Brokerage amount daalein"); return; }
    if (!period) { toast.error("Upar Period (month) select karein"); return; }
    setBusy(true);
    try {
      const { data } = await client.post("/partners/manual-brokerage", { ...f, mt5_id: f.mt5_id.trim(), amount: Number(f.amount), period, member_id: f.member_id || null });
      toast.success(`${data.member_name}: $${data.team_payout} added${data.client_created ? " · new client created" : ""}`);
      setF(BLANK); onSaved();
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  return (
    <div className="p-4 space-y-3 border-b border-[color:var(--border-subtle)]" data-testid="manual-brokerage">
      <div className="text-[11px] uppercase tracking-widest text-slate-500">Add Brokerage Manually</div>
      {members.length === 0 && <div data-testid="mb-no-partners" className="text-xs text-amber-400 border border-amber-500/40 bg-amber-500/5 p-2">Abhi koi team partner nahi hai — pehle "Add Partner" se partner banayein, phir brokerage add karein.</div>}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <Field label="MT5 ID"><input data-testid="mb-mt5" value={f.mt5_id} onChange={set("mt5_id")} className={`${inputCls} font-mono`} /></Field>
        <Field label="Brokerage amount (USD)"><input data-testid="mb-amount" type="number" value={f.amount} onChange={set("amount")} className={`${inputCls} font-mono`} /></Field>
        <Field label="Partner (optional)">
          <select data-testid="mb-partner" value={f.member_id} onChange={set("member_id")} className={inputCls}>
            <option value="">Auto (from MT5 ID)</option>
            {members.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
          </select>
        </Field>
        <Field label="Note (optional)"><input data-testid="mb-note" value={f.note} onChange={set("note")} className={inputCls} /></Field>
        {f.member_id && <Field label="Client name (if new MT5)"><input data-testid="mb-client-name" value={f.client_name} onChange={set("client_name")} className={inputCls} /></Field>}
        {f.member_id && <Field label="Broker (if new MT5)"><input data-testid="mb-broker" value={f.broker} onChange={set("broker")} className={inputCls} /></Field>}
      </div>
      <button data-testid="mb-save-btn" disabled={busy} onClick={save} className="btn-gold px-4 py-2 text-xs flex items-center gap-1.5 disabled:opacity-60"><PlusCircle size={14} />{busy ? "Saving…" : `Add for ${period}`}</button>
    </div>
  );
}
